import React from 'react';
import { useComponents } from '@tencent/dz-elements';
import { useMessageById } from '../../../hooks';
import styles from './style/index.less';
import { MessageType } from '@tencent/dz-models';
var SystemMessage = function (props) {
    var messageId = props.messageId;
    var messageState = useMessageById(messageId);
    var _a = messageState.payload.message, message = _a === void 0 ? '' : _a;
    var _b = useComponents(), View = _b.View, Text = _b.Text;
    return (React.createElement(View, { className: styles['system-message-container'] }, messageState.type === MessageType.SystemHistory ? React.createElement(View, { className: styles['system-history-message'] },
        React.createElement(View, { className: styles['system-history-divide'] }),
        React.createElement(View, { className: styles['system-history-content'] }, message),
        React.createElement(View, { className: styles['system-history-divide'] }))
        : React.createElement(View, { className: styles['system-message'] },
            React.createElement(Text, { className: styles['system-message-content'], content: message }))));
};
export default SystemMessage;
